export const pickStopLabels = (xs: {x: number; ep: boolean}[], minGap = 12): boolean[] => {
	const epXs = xs.filter((s) => s.ep).map((s) => s.x)
	let lastX = -Infinity
	return xs.map(({x, ep}) => {
		if (ep) {
			return true
		}
		const free = x - lastX >= minGap && epXs.every((e) => Math.abs(e - x) >= minGap)
		if (free) {
			lastX = x
		}
		return free
	})
}
